import React from 'react'

const AppContext = React.createContext({
  theme: false,
  isSideBarVisible: false,
  isBannerVisible: true,
  isliked: false,
  isDisliked: false,
  isSaved: false,
  savedVideoList: [],
  onClickUpdateSideBar: () => '',
  onClickToggleBanner: () => '',
  duration: () => '',
  onClickLikeBtn: () => '',
  onClickDislikeBth: () => '',
  onClickSaveBtn: () => '',
})

export default AppContext
